import script from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangeSelect.vue?vue&type=script&setup=true&lang=js"

import "./DateRangeSelect.vue?vue&type=style&index=0&id=56d51fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d51fa4"]])

export default __exports__